import axios from "axios";
import { Toast, Dialog } from "vant";
import router from "../router/index";
import { storage } from "./util.js";
import store from "../vuex/store";
import config from "../config/systemConfig";

axios.defaults.timeout = 50000; //请求超时时间
//axios.defaults.withCredentials=true;

var showToast = null;
// 请求拦截----------------------------------------------------------------
axios.interceptors.request.use(
    (config) => {
        const user = storage.getStorage("user");
        config.headers = {
            "Content-Type": "application/json",
        };
        if (user) {
            config.headers.token = user.token;
        }
        if (location.hostname === 'localhost' || location.hostname === '192.168.5.66') {
            config.headers.token = "f10e69eccccb051e6f34ddeac44236a7"
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 响应拦截----------------------------------------------------------------
axios.interceptors.response.use(
    function(res) {
        let status = res.data.code,
            message = res.data.message;
        // 如果是blob
        let responseType = res.data.type;
        if (responseType === "application/octet-stream") {
            return res;
        }
        switch (status) {
            case "2000":
                return res;
                break;
            case "3001":
                return { status: 3001, message: message};
                break;
            case "3000":
                debugger
                const appid = config.corpId;
                const agentid = config.agentId;
                const redirect_uri = encodeURIComponent(config.loginUrl);
                // const path = storage.getStorage("path");
                const path = window.location.href;
                let ref = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_privateinfo&state=${path}&agentid=${agentid}#wechat_redirect`;
                console.log(ref)
                // alert(ref)
                window.location.href = ref;
                break;
            default: //默认异常提示
                Dialog.alert({
                    title: "提示",
                    message: message ? message : "网络请求异常，请稍候再试",
                });
                break;
        }
    },
    (error) => {
        Dialog.alert({
            title: "提示",
            message: error.message.includes("timeout") ?
                "网络请求超时，请稍候再试" : "网络请求异常，请稍候再试",
        });
        return Promise.reject(error);
    }
);

/**
 * 封装请求
 * @param url
 * @param data
 * @param method
 * @param loading
 * @returns {Promise}
 */
export function apiAxios(url, params = {}, method = "post", loading = false) {
    if (loading) {
        showToast = Toast.loading({
            message: "加载中...",
            duration: 2000,
        });
    }
    method = method.toUpperCase(); //转成大写

    URL = config.hostServer + url
    if (location.hostname === 'localhost' || location.hostname === '192.168.5.66') {
        URL = "http://192.168.5.55:8101" + url
        URL = "https://server.jinzhimc.cn" + url // 金致
        // URL = "https://server.xcwsmc.com" + url // 欣成
        // URL = "https://server.heyingcgj.com" + url; // 合赢
        // URL = "https://server.fancemc.com" + url; // 范思泽
    }

    let conf = {
        method: method,
        url: URL,
        params: method === "GET" || method === "DELETE" ? params : null,
        data: method === "POST" || method === "PUT" ? params : null,
    };

    if (params.download) {
        conf.responseType = "blob";
    }
    return new Promise((resolve, reject) => {
        axios(conf)
            .then((res) => {
                if (loading) {
                    showToast.clear();
                }
                if (res) {
                    if (res.status === 200) {
                        resolve(res.data.data);
                    }
                    if (res.status === 3001) {
                        resolve({ error: true, message: res.message });
                    }
                }
            })
            .catch((response) => {
                if (loading) {
                    showToast.clear();
                }
                reject(response);
            });
    });
}


// WEBPACK FOOTER //
// ./src/utils/http.js